import React, { useEffect, useState, useRef } from "react";
import LoadingOverlay from "react-loading-overlay";
import { AgGridReact } from "ag-grid-react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Row, Col, Button } from "react-bootstrap";
import { VendorContract } from "../../../../components/VendorOnboarding/Views/DocumentCenter/VendorContract";
import Cookies from "js-cookie";

import DBMApprovalModal from "./DBMApprovalModal";

import {
  httpGetDBMSubmittedVendorDetail,
  httpPostAPRequestDBMApproval,
  httpGetDBMMEBSubmittedVendorDetail,
} from "../../../../service/httpClient";
import * as Constants from "../../../../constants/Constants";
import "./MBEApproval.css";

const MBEApproval = () => {
  const gridRef = useRef();

  const [responseData, setResponseData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showDBMApprovalModal, setShowDBMApprovalModal] = useState(false);
  const [approveBtnDisabled, setApproveBtnDisabled] = useState(false);
  const [approvalErrorMsg, setApprovalErrorMsg] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [vendorId, setVendorId] = useState(""); 
  const store = useSelector(
    ({  common }) => ({
      onboardingStatus: common.onboardingStatus,
    }),
    shallowEqual
  );
  const columnDefs = [
    {
      headerName: " ",
      field: "vendorId", //vendorProfileId
      width: 40,
      filter: false,
      sortable: false,
      hide: true,
    },
    {
      headerName: "Vendor Name",
      field: "vendorName",
      width: 150,
      comparator: stringDataComparator,
    },
    {
      headerName: "Brand Name",
      field: "brandName",
      width: 110,
      comparator: stringDataComparator,
    },
    {
      headerName: "Duns #",
      field: "duns",
      width: 80,
      comparator: stringNumericDataComparator,
    },
    {
      headerName: "Vendor Fulfillment Type",
      field: "vendorFullFillmentType",
      width: 160,
      comparator: stringDataComparator,
    },
    {
      headerName: "Vendor Connection",
      field: "vendorConnectionPlatform",
      width: 120,
      comparator: stringDataComparator,
    },
    {
      headerName: "Merchant Email",
      field: "merchantEmail",
      width: 200,
      comparator: stringDataComparator,
    },
    {
      headerName: "Operating Division(s)",
      field: "operatingDivisions",
      width: 180,
      comparator: operatingDivisionComparator,
    },
    {
      headerName: "GMM(s)",
      field: "gmmNames",
      width: 200,
      comparator: gmmAndDivisionComparator,
    },
    {
      headerName: "Division(s)",
      field: "divisionNames",
      width: 120,
      comparator: gmmAndDivisionComparator,
    },
    {
      headerName: "Dept(s)",
      field: "depts",
      width: 100,
      comparator: departmentComparator,
    },
    {
      headerName: "Product Type",
      field: "productType",
      width: 100,
      comparator: stringNumericDataComparator,
    },
    {
      headerName: "Annual Sales Volume",
      field: "annualSalesVolume",
      width: 140,
      comparator: numericDataComparator,
    },
    {
      headerName: "Documents Submitted Date",
      field: "documentsSubmittedDate",
      width: 180,
    },
  ];
  const defaultColDef = {
    lockVisible: true,
    suppressMovable: true,
    enablePivot: true,
    filter: true,
    sortable: true,
    resizable: true,
  };

  function stringDataComparator(valueA, valueB) {
    const valueALower =
      valueA && valueA !== "" ? valueA.toLowerCase().trim() : valueA;
    const valueBLower =
      valueB && valueB !== "" ? valueB.toLowerCase().trim() : valueB;
    if (valueALower && valueBLower) {
      return valueALower === valueBLower
        ? 0
        : valueALower.localeCompare(valueBLower, "en", { numeric: true });
    } else if (valueALower && (valueBLower === null || valueBLower === "")) {
      return -1;
    } else if ((valueALower === null || valueALower === "") && valueBLower) {
      return 1;
    } else {
      return -1;
    }
  }

  function operatingDivisionComparator(valueA, valueB) {
    const valueALower =
      valueA && valueA !== "" ? valueA.toLowerCase().trim() : valueA;
    const valueBLower =
      valueB && valueB !== "" ? valueB.toLowerCase().trim() : valueB;
    const arrayValueA =
      valueALower && valueALower.indexOf(",") > -1
        ? valueALower.split(",")
        : valueALower && valueALower !== ""
        ? [valueALower]
        : [];
    const arrayValueB =
      valueBLower && valueBLower.indexOf(",") > -1
        ? valueBLower.split(",")
        : valueBLower && valueBLower !== ""
        ? [valueBLower]
        : [];
    const valueA0 =
      arrayValueA.length !== 0 && arrayValueA[0] ? arrayValueA[0] : null;
    const valueA1 =
      arrayValueA.length !== 0 && arrayValueA[1] ? arrayValueA[1] : null;
    const valueA2 =
      arrayValueA.length !== 0 && arrayValueA[2] ? arrayValueA[2] : null;
    const valueA3 =
      arrayValueA.length !== 0 && arrayValueA[3] ? arrayValueA[3] : null;
    const valueB0 =
      arrayValueB.length !== 0 && arrayValueB[0] ? arrayValueB[0] : null;
    const valueB1 =
      arrayValueB.length !== 0 && arrayValueB[1] ? arrayValueB[1] : null;
    const valueB2 =
      arrayValueB.length !== 0 && arrayValueB[2] ? arrayValueB[2] : null;
    const valueB3 =
      arrayValueB.length !== 0 && arrayValueB[3] ? arrayValueB[3] : null;

    if (valueA0 && valueB0) {
      if (valueA0 === valueB0) {
        if (valueA1 && valueB1) {
          if (valueA1 === valueB1) {
            if (valueA2 && valueB2) {
              if (valueA2 === valueB2) {
                if (valueA3 && valueB3) {
                  if (valueA3 === valueB3) {
                    return 0;
                  } else {
                    return valueA3.localeCompare(valueB3, "en", {
                      numeric: true,
                    });
                  }
                } else if (valueA3 && (valueB3 === null || valueB3 === "")) {
                  return -1;
                } else if ((valueA3 === null || valueA3 === "") && valueB3) {
                  return 1;
                } else {
                  return 0;
                }
              } else {
                return valueA2.localeCompare(valueB2, "en", { numeric: true });
              }
            } else if (valueA2 && (valueB2 === null || valueB2 === "")) {
              return -1;
            } else if ((valueA2 === null || valueA2 === "") && valueB2) {
              return 1;
            } else {
              return 0;
            }
          } else {
            return valueA1.localeCompare(valueB1, "en", { numeric: true });
          }
        } else if (valueA1 && (valueB1 === null || valueB1 === "")) {
          return -1;
        } else if ((valueA1 === null || valueA1 === "") && valueB1) {
          return 1;
        } else {
          return 0;
        }
      } else {
        return valueA0.localeCompare(valueB0, "en", { numeric: true });
      }
    } else if (valueA0 && (valueB0 === null || valueB0 === "")) {
      return -1;
    } else if ((valueA0 === null || valueA0 === "") && valueBLower) {
      return 1;
    } else {
      return -1;
    }
  }

  function stringNumericDataComparator(valueA, valueB) {
    const valueALower =
      valueA && valueA !== "" ? valueA.toLowerCase().trim() : valueA;
    const valueBLower =
      valueB && valueB !== "" ? valueB.toLowerCase().trim() : valueB;
    if (valueALower && valueBLower) {
      if (!isNaN(valueALower) && !isNaN(valueBLower)) {
        return parseInt(valueALower, 10) === parseInt(valueBLower, 10)
          ? 0
          : parseInt(valueALower, 10) > parseInt(valueBLower, 10)
          ? 1
          : -1;
      } else if (isNaN(valueALower) && !isNaN(valueBLower)) {
        return 1;
      } else if (!isNaN(valueALower) && isNaN(valueBLower)) {
        return -1;
      } else {
        return valueALower === valueBLower
          ? 0
          : valueALower.localeCompare(valueBLower, "en", { numeric: true });
      }
    } else if (valueALower && (valueBLower === null || valueBLower === "")) {
      return -1;
    } else if ((valueALower === null || valueALower === "") && valueBLower) {
      return 1;
    } else {
      return -1;
    }
  }

  function numericDataComparator(valueA, valueB) {
    //Split the values by separator " - " & " , "

    //Take the left side value
    const valueA0 =
      valueA && valueA.indexOf("-") > -1
        ? valueA.split("-")[0]
        : valueA && valueA.indexOf(",") > -1
        ? valueA.split(",")[0]
        : valueA;
    const valueB0 =
      valueB && valueB.indexOf("-") > -1
        ? valueB.split("-")[0]
        : valueB && valueB.indexOf(",") > -1
        ? valueB.split(",")[0]
        : valueB;

    //Take the right side value
    const valueA1 =
      valueA && valueA.indexOf("-") > -1
        ? valueA.split("-")[1]
        : valueA && valueA.indexOf(",") > -1
        ? valueA.split(",")[1]
        : null;
    const valueB1 =
      valueB && valueB.indexOf("-") > -1
        ? valueB.split("-")[1]
        : valueB && valueB.indexOf(",") > -1
        ? valueB.split(",")[1]
        : null;

    if (valueA0 && valueB0) {
      if (parseInt(valueA0.trim(), 10) === parseInt(valueB0.trim(), 10)) {
        if (valueA1 && valueB1 && !isNaN(valueA1) && !isNaN(valueB1)) {
          return parseInt(valueA1.trim(), 10) === parseInt(valueB1.trim(), 10)
            ? 0
            : parseInt(valueA1.trim(), 10) > parseInt(valueB1.trim(), 10)
            ? 1
            : -1;
        } else if (valueA1 && valueB1 && isNaN(valueA1) && isNaN(valueB1)) {
          return valueA1.trim().toLowerCase() === valueB1.trim().toLowerCase()
            ? 0
            : valueA1.trim().toLowerCase() > valueB1.trim().toLowerCase()
            ? 1
            : -1;
        } else {
          return 0;
        }
      } else {
        return parseInt(valueA0.trim(), 10) > parseInt(valueB0.trim(), 10)
          ? 1
          : -1;
      }
    } else if (valueA0 && valueB0 === null) {
      return -1;
    } else if (valueA0 === null && valueB0) {
      return 1;
    } else {
      return -1;
    }
  }

  function departmentComparator(valueA, valueB) {
    const arrayValueA =
      valueA && valueA.indexOf(",") > -1
        ? valueA.split(",")
        : valueA && valueA !== ""
        ? [valueA]
        : [];
    const arrayValueB =
      valueB && valueB.indexOf(",") > -1
        ? valueB.split(",")
        : valueB && valueB !== ""
        ? [valueB]
        : [];
    const valueA0 =
      arrayValueA.length !== 0 && arrayValueA[0] ? arrayValueA[0] : null;
    const valueA1 =
      arrayValueA.length !== 0 && arrayValueA[1] ? arrayValueA[1] : null;
    const valueA2 =
      arrayValueA.length !== 0 && arrayValueA[2] ? arrayValueA[2] : null;
    const valueA3 =
      arrayValueA.length !== 0 && arrayValueA[3] ? arrayValueA[3] : null;
    const valueB0 =
      arrayValueB.length !== 0 && arrayValueB[0] ? arrayValueB[0] : null;
    const valueB1 =
      arrayValueB.length !== 0 && arrayValueB[1] ? arrayValueB[1] : null;
    const valueB2 =
      arrayValueB.length !== 0 && arrayValueB[2] ? arrayValueB[2] : null;
    const valueB3 =
      arrayValueB.length !== 0 && arrayValueB[3] ? arrayValueB[3] : null;

    if (valueA0 && valueB0) {
      if (parseInt(valueA0.trim(), 10) === parseInt(valueB0.trim(), 10)) {
        if (valueA1 && valueB1) {
          if (parseInt(valueA1.trim(), 10) === parseInt(valueB1.trim(), 10)) {
            if (valueA2 && valueB2) {
              if (
                parseInt(valueA2.trim(), 10) === parseInt(valueB2.trim(), 10)
              ) {
                if (valueA3 && valueB3) {
                  return parseInt(valueA2.trim(), 10) ===
                    parseInt(valueB2.trim(), 10)
                    ? 0
                    : parseInt(valueA2.trim(), 10) >
                      parseInt(valueB2.trim(), 10)
                    ? 1
                    : -1;
                } else if (valueA3 && valueB3 === null) {
                  return -1;
                } else if (valueA3 === null && valueB3) {
                  return 1;
                } else {
                  return -1;
                }
              } else {
                return parseInt(valueA2.trim(), 10) >
                  parseInt(valueB2.trim(), 10)
                  ? 1
                  : -1;
              }
            } else if (valueA2 && valueB2 === null) {
              return -1;
            } else if (valueA2 === null && valueB2) {
              return 1;
            } else {
              return -1;
            }
          } else {
            return parseInt(valueA1.trim(), 10) > parseInt(valueB1.trim(), 10)
              ? 1
              : -1;
          }
        } else if (valueA1 && valueB1 === null) {
          return -1;
        } else if (valueA1 === null && valueB1) {
          return 1;
        } else {
          return -1;
        }
      } else {
        return parseInt(valueA0.trim(), 10) > parseInt(valueB0.trim(), 10)
          ? 1
          : -1;
      }
    } else if (valueA0 && valueB0 === null) {
      return -1;
    } else if (valueA0 === null && valueB0) {
      return 1;
    } else {
      return -1;
    }
  }

  function gmmAndDivisionComparator(valueA, valueB) {
    const arrayValueA =
      valueA && valueA.indexOf(",") > -1
        ? valueA.split(",")
        : valueA && valueA !== ""
        ? [valueA]
        : [];
    const arrayValueB =
      valueB && valueB.indexOf(",") > -1
        ? valueB.split(",")
        : valueB && valueB !== ""
        ? [valueB]
        : [];
    const valueA0 =
      arrayValueA.length !== 0 && arrayValueA[0] ? arrayValueA[0] : null;
    const valueA1 =
      arrayValueA.length !== 0 && arrayValueA[1] ? arrayValueA[1] : null;
    const valueA2 =
      arrayValueA.length !== 0 && arrayValueA[2] ? arrayValueA[2] : null;
    const valueA3 =
      arrayValueA.length !== 0 && arrayValueA[3] ? arrayValueA[3] : null;
    const valueB0 =
      arrayValueB.length !== 0 && arrayValueB[0] ? arrayValueB[0] : null;
    const valueB1 =
      arrayValueB.length !== 0 && arrayValueB[1] ? arrayValueB[1] : null;
    const valueB2 =
      arrayValueB.length !== 0 && arrayValueB[2] ? arrayValueB[2] : null;
    const valueB3 =
      arrayValueB.length !== 0 && arrayValueB[3] ? arrayValueB[3] : null;

    const valueA00 =
      valueA0 && valueA0.indexOf("-") > -1 ? valueA0.split("-")[0] : valueA0;
    const valueA01 =
      valueA0 && valueA0.indexOf("-") > -1 ? valueA0.split("-")[1] : null;
    const valueA10 =
      valueA1 && valueA1.indexOf("-") > -1 ? valueA1.split("-")[0] : valueA1;
    const valueA11 =
      valueA1 && valueA1.indexOf("-") > -1 ? valueA1.split("-")[1] : null;
    const valueA20 =
      valueA2 && valueA2.indexOf("-") > -1 ? valueA2.split("-")[0] : valueA2;
    const valueA21 =
      valueA2 && valueA2.indexOf("-") > -1 ? valueA2.split("-")[1] : null;
    const valueA30 =
      valueA3 && valueA3.indexOf("-") > -1 ? valueA3.split("-")[0] : valueA3;
    const valueA31 =
      valueA3 && valueA3.indexOf("-") > -1 ? valueA3.split("-")[1] : null;

    const valueB00 =
      valueB0 && valueB0.indexOf("-") > -1 ? valueB0.split("-")[0] : valueB0;
    const valueB01 =
      valueB0 && valueB0.indexOf("-") > -1 ? valueB0.split("-")[1] : null;
    const valueB10 =
      valueB1 && valueB1.indexOf("-") > -1 ? valueB1.split("-")[0] : valueB1;
    const valueB11 =
      valueB1 && valueB1.indexOf("-") > -1 ? valueB1.split("-")[1] : null;
    const valueB20 =
      valueB2 && valueB2.indexOf("-") > -1 ? valueB2.split("-")[0] : valueB2;
    const valueB21 =
      valueB2 && valueB2.indexOf("-") > -1 ? valueB2.split("-")[1] : null;
    const valueB30 =
      valueB3 && valueB3.indexOf("-") > -1 ? valueB3.split("-")[0] : valueB3;
    const valueB31 =
      valueB3 && valueB3.indexOf("-") > -1 ? valueB3.split("-")[1] : null;

    if (valueA00 && valueB00) {
      if (parseInt(valueA00.trim(), 10) === parseInt(valueB00.trim(), 10)) {
        if (valueA01 && valueB01) {
          if (valueA01 === valueB01) {
            if (valueA10 && valueB10) {
              if (
                parseInt(valueA10.trim(), 10) === parseInt(valueB10.trim(), 10)
              ) {
                if (valueA11 && valueB11) {
                  if (valueA11 === valueB11) {
                    if (valueA20 && valueB20) {
                      if (
                        parseInt(valueA20.trim(), 10) ===
                        parseInt(valueB20.trim(), 10)
                      ) {
                        if (valueA21 && valueB21) {
                          if (valueA21 === valueB21) {
                            if (valueA30 && valueB30) {
                              if (
                                parseInt(valueA30.trim(), 10) ===
                                parseInt(valueB30.trim(), 10)
                              ) {
                                if (valueA31 && valueB31) {
                                  if (valueA31 === valueB31) {
                                    return 0;
                                  } else {
                                    if (
                                      valueA31 &&
                                      valueB31 &&
                                      !isNaN(valueA31) &&
                                      !isNaN(valueB31)
                                    ) {
                                      return parseInt(valueA31.trim(), 10) ===
                                        parseInt(valueB31.trim(), 10)
                                        ? 0
                                        : parseInt(valueA31.trim(), 10) >
                                          parseInt(valueB31.trim(), 10)
                                        ? 1
                                        : -1;
                                    } else if (
                                      valueA31 &&
                                      valueB31 &&
                                      isNaN(valueA31) &&
                                      isNaN(valueB31)
                                    ) {
                                      return valueA31.trim().toLowerCase() ===
                                        valueB31.trim().toLowerCase()
                                        ? 0
                                        : valueA31.trim().toLowerCase() >
                                          valueB31.trim().toLowerCase()
                                        ? 1
                                        : -1;
                                    } else {
                                      return 0;
                                    }
                                  }
                                }
                              } else {
                                return parseInt(valueA30.trim(), 10) >
                                  parseInt(valueB30.trim(), 10)
                                  ? 1
                                  : -1;
                              }
                            } else if (valueA30 && valueB30 === null) {
                              return -1;
                            } else if (valueA30 === null && valueB30) {
                              return 1;
                            } else {
                              return -1;
                            }
                          } else {
                            if (
                              valueA21 &&
                              valueB11 &&
                              !isNaN(valueA21) &&
                              !isNaN(valueB21)
                            ) {
                              return parseInt(valueA21.trim(), 10) ===
                                parseInt(valueB21.trim(), 10)
                                ? 0
                                : parseInt(valueA21.trim(), 10) >
                                  parseInt(valueB21.trim(), 10)
                                ? 1
                                : -1;
                            } else if (
                              valueA21 &&
                              valueB21 &&
                              isNaN(valueA21) &&
                              isNaN(valueB21)
                            ) {
                              return valueA21.trim().toLowerCase() ===
                                valueB21.trim().toLowerCase()
                                ? 0
                                : valueA21.trim().toLowerCase() >
                                  valueB21.trim().toLowerCase()
                                ? 1
                                : -1;
                            } else {
                              return 0;
                            }
                          }
                        }
                      } else {
                        return parseInt(valueA20.trim(), 10) >
                          parseInt(valueB20.trim(), 10)
                          ? 1
                          : -1;
                      }
                    } else if (valueA20 && valueB20 === null) {
                      return -1;
                    } else if (valueA20 === null && valueB20) {
                      return 1;
                    } else {
                      return -1;
                    }
                  } else {
                    if (
                      valueA11 &&
                      valueB11 &&
                      !isNaN(valueA11) &&
                      !isNaN(valueB11)
                    ) {
                      return parseInt(valueA11.trim(), 10) ===
                        parseInt(valueB11.trim(), 10)
                        ? 0
                        : parseInt(valueA11.trim(), 10) >
                          parseInt(valueB11.trim(), 10)
                        ? 1
                        : -1;
                    } else if (
                      valueA11 &&
                      valueB11 &&
                      isNaN(valueA11) &&
                      isNaN(valueB11)
                    ) {
                      return valueA11.trim().toLowerCase() ===
                        valueB11.trim().toLowerCase()
                        ? 0
                        : valueA11.trim().toLowerCase() >
                          valueB11.trim().toLowerCase()
                        ? 1
                        : -1;
                    } else {
                      return 0;
                    }
                  }
                }
              } else {
                return parseInt(valueA10.trim(), 10) >
                  parseInt(valueB10.trim(), 10)
                  ? 1
                  : -1;
              }
            } else if (valueA10 && valueB10 === null) {
              return -1;
            } else if (valueA10 === null && valueB10) {
              return 1;
            } else {
              return -1;
            }
          } else {
            if (valueA01 && valueB01 && !isNaN(valueA01) && !isNaN(valueB01)) {
              return parseInt(valueA01.trim(), 10) ===
                parseInt(valueB01.trim(), 10)
                ? 0
                : parseInt(valueA01.trim(), 10) > parseInt(valueB01.trim(), 10)
                ? 1
                : -1;
            } else if (
              valueA01 &&
              valueB01 &&
              isNaN(valueA01) &&
              isNaN(valueB01)
            ) {
              return valueA01.trim().toLowerCase() ===
                valueB01.trim().toLowerCase()
                ? 0
                : valueA01.trim().toLowerCase() > valueB01.trim().toLowerCase()
                ? 1
                : -1;
            } else {
              return 0;
            }
          }
        }
      } else {
        return parseInt(valueA00.trim(), 10) > parseInt(valueB00.trim(), 10)
          ? 1
          : -1;
      }
    } else if (valueA00 && valueB00 === null) {
      return -1;
    } else if (valueA00 === null && valueB00) {
      return 1;
    } else {
      return -1;
    }
  }

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    httpGetDBMMEBSubmittedVendorDetail(Cookies.get("email"), Constants.DEI_TYPE)
      .then((response) => {
        const { data = [], status } = response || {};

        if (data && data?.length > 0 && status === 200) {
          setResponseData(data);
          setIsLoading(false);
        } else {
          setResponseData([]);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      });
  };

  const toggleDBMApprovalModal = (flag) => {
    setShowDBMApprovalModal(flag);
  };

  const resetDBMApprovalData = () => {
    setSelectedRows([]);
    setShowDBMApprovalModal(false);
  };

  const onSelectionChanged = () => {
    const gridRows = gridRef.current.api.getSelectedRows();
    setShowModal(true);
    setVendorId(gridRows[0].vendorId);
    setSelectedRows(gridRows.map((item) => Number(item.vendorId))); //vendorProfileId
  };

  const handleSubmit = () => {
    setApproveBtnDisabled(true);
    httpPostAPRequestDBMApproval({
      vendorProfileIds: selectedRows,
      merchApprovedBy: Cookies.get("email"),
    })
      .then((res) => {
        if (res && res.status === 200) {
          setApprovalErrorMsg("");
          setApproveBtnDisabled(false);
          toggleDBMApprovalModal(false);
          resetDBMApprovalData();
          gridRef.current.api.deselectAll();
          setIsLoading(true);
          getData();
        } else {
          throw new Error("Something went wrong, try after sometime!");
        }
      })
      .catch((error) => {
        console.log(error);
        if (
          error.response &&
          (error.response.status === 400 || error.response.status === 404)
        ) {
          setApprovalErrorMsg(error.response?.data?.message);
        } else {
          setApprovalErrorMsg(error.message);
        }
        setApproveBtnDisabled(false);
      });
  };

  return (
    <div className="mbeApproval">
      <LoadingOverlay active={isLoading} spinner>
        <div className="mbeApprovalHeading">
          {Constants.MY_VENDORS} ({responseData && responseData?.length})
        </div>
        {showModal && (
          <VendorContract
            vendorId={vendorId}
            onboardingStatus={store.onboardingStatus}
            contractType={Constants.DEI_TYPE}
            refreshDataAfterActionSuccessful={getData}
            selectedRows={selectedRows}
            isFrom={'mbeDashboard'}
          />
        )}
        <div className="ag-theme-balham mbeApprovalTable">
          <AgGridReact
            ref={gridRef}
            columnDefs={columnDefs}
            rowData={responseData}
            defaultColDef={defaultColDef}
            rowSelection="single"
            paginationPageSize="20"
            enableRangeSelection={true}
            pagination={true}
            overlayNoRowsTemplate={
              responseData.length > 0 ? "" : "No DBM Approval detail available"
            }
            onSelectionChanged={onSelectionChanged}
          />
          <DBMApprovalModal
            show={showDBMApprovalModal}
            onModalClose={() => {
              setApprovalErrorMsg("");
              setApproveBtnDisabled(false);
              toggleDBMApprovalModal(false);
            }}
            onSubmit={handleSubmit}
            approveBtnDisabled={approveBtnDisabled}
            approvalErrorMsg={approvalErrorMsg}
          />
        </div>      
      </LoadingOverlay>
    </div>
  );
};

export default MBEApproval;
